export const LIMIT_LABELS: Record<string, string> = {
  MaxMembers: 'Members',
  MaxActiveEvents: 'Active Events',
  MaxUsersPerBu: 'Users',
  MaxCustomFieldDefs: 'Custom Field Definitions',
  MaxPaymentsPerMonth: 'Payments per Month',
  MaxLedgerEntriesPerYear: 'Ledger Entries per Year',
};

export const FEATURE_LABELS: Record<string, string> = {
  FeatureEventManagement: 'Event Management',
  FeatureInvitations: 'Invitations',
  FeatureCustomFields: 'Custom Fields',
  FeatureBulkPayments: 'Bulk Payments',
  FeatureSms: 'SMS Notifications',
  FeatureEmail: 'Email Notifications',
  FeatureAdvancedReports: 'Advanced Reports',
  FeatureAuditLog: 'Audit Log',
  FeatureChangeRequests: 'Change Requests',
  FeatureReceiptTemplates: 'Receipt Templates',
};

export function isGatedErrorCode(code?: string | null): boolean {
  return code === 'LIMIT_REACHED' || code === 'FEATURE_NOT_INCLUDED';
}
